import defaultSettings from '@/config'

const { logo, layout, themeBar, style, themeColor } = defaultSettings

const theme = JSON.parse(localStorage.getItem('eip-front-theme')) || ''

const state = () => ({
  logo,
  collapse: false,
  layout: theme.layout || layout,
  style: theme.style || style,
  themeColor: theme.themeColor || themeColor,
  themeBar,
})

const getters = {
  collapse: (state) => state.collapse,
  layout: (state) => state.layout,
  style: (state) => state.style,
  logo: (state) => state.logo,
  themeBar: (state) => state.themeBar,
  themeColor: (state) => state.themeColor,
}

const mutations = {
  changeLayout: (state, layout) => {
    if (layout) state.layout = layout
  },
  changeStyle: (state, style) => {
    if (style) state.style = style
  },
  changeThemeColor: (state, themeColor) => {
    if (style) state.themeColor = themeColor
  },
  changeCollapse: (state) => {
    state.collapse = !state.collapse
  },
  foldSideBar: (state) => {
    state.collapse = true
  },
  openSideBar: (state) => {
    state.collapse = false
  },
}

const actions = {
  changeStyle({ commit }, style) {
    commit('changeStyle', style)
  },
  changeLayout({ commit }, layout) {
    commit('changeLayout', layout)
  },
  changeThemeColor({ commit }, themeColor) {
    commit('changeThemeColor', themeColor)
  },
  changeCollapse({ commit }) {
    commit('changeCollapse')
  },
  foldSideBar({ commit }) {
    commit('foldSideBar')
  },
  openSideBar({ commit }) {
    commit('openSideBar')
  },
}

export default { state, getters, mutations, actions }
